<script setup lang="ts">
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import KBtn from '@/components/btns/KBtn.vue';
import SecondarySideBarMenuVListItem from '@/components/items/SecondarySideBarMenuVListItem.vue';

export type ReturnLabelsFormat = openapi.PostReportReturnLabels_Body['format'];

export interface Props {
  disabled?: boolean;
  loading?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
});
const emit = defineEmits<{
  downloadClick: [format: ReturnLabelsFormat];
}>();

const pdfFormat: ReturnLabelsFormat = 'pdf';
const zplFormat: ReturnLabelsFormat = 'zpl';

function handleDownloadClick(format: ReturnLabelsFormat): void {
  emit('downloadClick', format);
}
</script>

<template>
  <div
    :class="$style.returnLabelsDownloadVMenu"
    data-testid="returnLabelsDownloadVMenu"
  >
    <v-menu transition="slide-y-transition">
      <template #activator="{ props: menuProps }">
        <KBtn
          v-bind="menuProps"
          size="lg"
          append-icon="mdi-chevron-down"
          :disabled="props.disabled"
          :loading="props.loading"
        >
          Return labels
        </KBtn>
      </template>
      <v-list density="compact">
        <SecondarySideBarMenuVListItem
          prepend-icon="mdi-file-pdf-box"
          @click="handleDownloadClick(pdfFormat)"
        >
          Download PDF
        </SecondarySideBarMenuVListItem>
        <SecondarySideBarMenuVListItem
          prepend-icon="mdi-code-braces"
          @click="handleDownloadClick(zplFormat)"
        >
          Download ZPL
        </SecondarySideBarMenuVListItem>
      </v-list>
    </v-menu>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.returnLabelsDownloadVMenu {
  display: contents;
}
</style>
